module.exports = __webpack_public_path__ + "img/video_standard.e3e6d487.svg";